// eslint-disable-next-line import/no-anonymous-default-export
export default (location = [], action) => {
  switch (action.type) {
    case "GET_ALL_RIGHT_OF_USE_ASSET":
      return action.payload;

    case "CREATE_RIGHT_OF_USE_ASSET":
      return [...location, action.payload];

    default:
      return location;
  }
};
